<onyx-section heading="labels.end">
  <onyx-checkbox
    rightHeading
    [formControl]="isReturningControl()"
    label="labels.beginReturn"
  ></onyx-checkbox>

  <div class="container">
    @let controls = form().controls;
    <form [formGroup]="form()">
      <onyx-form-group [controls]="controls.arrivalPlace">
        <onyx-address-input
          [formControl]="controls.arrivalPlace"
          label="labels.address"
          [showApartment]="true"
          apartmentWidth="80px"
          [showErrors]="false"
          [size]="32"
        ></onyx-address-input>

        <onyx-suggestions
          [control]="controls.arrivalPlace"
          [suggestions]="addressSuggestions()"
        ></onyx-suggestions>
      </onyx-form-group>

      <onyx-form-group [controls]="controls.arrivalDate">
        <onyx-datepicker
          [formControl]="controls.arrivalDate"
          [label]="`labels.${hasDailyReturns() ? 'endDate' : 'arrivalDate'}`"
          [showErrors]="false"
          [warningTypes]="['pastDate']"
          [size]="32"
        ></onyx-datepicker>

        <onyx-suggestions
          [control]="controls.arrivalDate"
          [suggestions]="DATE_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>

      <onyx-timepicker
        [formControl]="controls.arrivalTime"
        [label]="`labels.${hasDailyReturns() ? 'arrivalTimes' : 'arrivalTime'}`"
        [size]="32"
      ></onyx-timepicker>
    </form>

    @for (warning of warnings(); track warning) {
      <onyx-message intent="warning">
        <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

        <p
          [innerHTML]="`${I18N}.${warning.message}` | translate: warning.data"
        ></p>
      </onyx-message>
    }

    @for (
      unavailability of driversUnavailability();
      track unavailability.data.driver
    ) {
      <onyx-message intent="error">
        <onyx-icon name="error-filled" [size]="20"></onyx-icon>

        <p
          [innerHTML]="
            `${I18N}.${unavailability.message}`
              | translate
                : {
                    driver: unavailability.data.driver,
                    unavailabilities: unavailability.data.unavailabilities,
                  }
          "
        ></p>
      </onyx-message>
    }
  </div>
</onyx-section>
